'use client';

import type { ReactNode } from 'react';

import { FilterProviderAppRouter } from '@/src/lib/filters';
import { AllFiltersModalProvider } from '@/src/components/ListingSearch/AllFiltersModalProvider';
import { HeaderVisibilityProvider } from '@/src/layouts/HeaderVisibilityContext';
import { SrpPageViewCoordinatorProvider } from '@/src/analytics/SrpPageViewCoordinator';
import { RecentSearchPersistence } from './RecentSearchPersistence';
import { SearchViewModeProvider } from './SearchViewModeContext';

// SavedListingsProvider lives in the global Providers (src/app/providers.tsx) — it's
// needed by <ListingCard> on non-resource routes (homepage FeaturedRentals etc.).
// AllFiltersModalProvider hosts the All-Filters modal at this persistent shell level
// so it survives the SRP slug morph (which remounts the page-level search bar).
export function SearchShellProviders({
  children,
  initialHideHeaderOnMobile,
}: {
  children: ReactNode;
  initialHideHeaderOnMobile?: boolean;
}) {
  return (
    <SrpPageViewCoordinatorProvider>
      <FilterProviderAppRouter>
        <RecentSearchPersistence />
        <AllFiltersModalProvider>
          <SearchViewModeProvider>
            <HeaderVisibilityProvider initialHideHeaderOnMobile={initialHideHeaderOnMobile}>
              {children}
            </HeaderVisibilityProvider>
          </SearchViewModeProvider>
        </AllFiltersModalProvider>
      </FilterProviderAppRouter>
    </SrpPageViewCoordinatorProvider>
  );
}
